export default "__VITE_ASSET__Bn4Qq4Eu__"